import React from 'react'
import ContactUs from './ContactUs'

function Support() {
    return (
        <div>
            <ContactUs />
        </div>
    )
}

export default Support
